import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g id="icon/system/arrow filled">
    <path
      id="Combined Shape"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.0001 25.8667C20.4401 25.8667 25.6667 20.64 25.6667 14.2C25.6667 7.76003 20.4401 2.53337 14.0001 2.53337C7.56008 2.53337 2.33342 7.76003 2.33342 14.2C2.33342 20.64 7.56008 25.8667 14.0001 25.8667ZM9.6896 13.3337L15.4236 7.55876C15.8986 7.08035 16.6687 7.08035 17.1437 7.55876C17.6188 8.03717 17.6188 8.81283 17.1437 9.29125L12.2699 14.2L17.1437 19.1087C17.6188 19.5871 17.6188 20.3627 17.1437 20.8411C16.6687 21.3196 15.8986 21.3196 15.4236 20.8411L9.6896 15.0662C9.21458 14.5878 9.21458 13.8121 9.6896 13.3337Z"
      fill={fill}
    />
  </g>
);

export default Icon;
